// Site-wide configuration and metadata
export const site = {
  title: 'SlideFactory - AI-Powered Presentation Automation',
  description: 'Transform ideas, data, and documents into professional PowerPoint presentations at scale. Multi-AI support, workflow integration, enterprise security.',
  author: 'SlideFactory',
  favicon: '/favicon.png',

  // Navigation
  nav: {
    logo: 'SlideFactory',
    links: [
      { label: 'Get Started', href: '#cta' },
      { label: 'Documentation', href: 'https://docs.slidefactory.app' }
    ],
    menu: [
      { label: 'Home', href: '#intro' },
      { label: 'Features', href: '#features' },
      { label: 'Use Cases', href: '#infos' },
      { label: 'Stats', href: '#stats' },
      { label: 'How It Works', href: '#how-it-works' },
      { label: 'Get Started', href: '#cta' }
    ],
    resources: [
      { label: 'Documentation', href: 'https://docs.slidefactory.app' },
      { label: 'GitHub', href: 'https://github.com/slidefactory' }
    ]
  },

  // Footer
  footer: {
    social: [
      { icon: 'fa-linkedin', href: 'https://linkedin.com/company/slidefactory' },
      { icon: 'fa-twitter', href: 'https://twitter.com/slidefactory' },
      { icon: 'fa-github', href: 'https://github.com/slidefactory' }
    ],
    company: {
      name: 'SlideFactory',
      tagline: 'AI Presentation Automation',
      description: 'Enterprise Solutions'
    },
    contact: {
      email: 'contact@slidefactory.app',
      support: 'support@slidefactory.app'
    },
    links: [
      { label: 'Documentation', href: 'https://docs.slidefactory.app' },
      { label: 'API Reference', href: 'https://docs.slidefactory.app/api' },
      { label: 'Privacy Policy', href: '/privacy.html' },
      { label: 'Terms of Service', href: '/terms.html' }
    ],
    copyright: {
      year: 2025,
      company: 'SlideFactory',
      tagline: 'AI-powered presentation automation.'
    }
  }
}
